// extracted by mini-css-extract-plugin
module.exports = {"Funnel":"Funnel_Funnel___pjEa","tagsContainer":"Funnel_tagsContainer__2yybI"};